import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {SelectionItemDto} from '../../../dto/SelectionItemDto';
import {CommunicationService} from '../../../service/communication.service';
import {DialogViewModelCreatorService} from '../../../service/dialog-view-model-creator.service';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {ImmediatelyRenderedMessageComponent} from '../immediately-rendered-message-component';

@Component({
    templateUrl: './selection-list-message.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectionListMessageComponent extends ImmediatelyRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'selectionlist';

    constructor(private communicationService: CommunicationService,
                public dialogViewModelCreator: DialogViewModelCreatorService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    public async selectItem(chosenItem: SelectionItemDto, items: SelectionItemDto[]): Promise<void> {
        // Data can be any
        // eslint-disable-next-line
        if (!this.message.data.responseItemData.disableSelectionList) {
            const text = chosenItem.buttonMessage;
            this.dialogViewModelCreator.addUserTextMessage(text);
            await this.communicationService.sendMessage(text, 'selectionlist');
            items.forEach((item) => {
                item.selected = item === chosenItem;
            });
        }
        // Data can be any

        this.message.data.responseItemData.disableSelectionList = this.message.data.responseItemData.disableAfterClick;
        // The item selection and the disabled state are set after the awaited send, outside the click handler's change detection
        this.changeDetectorRef.markForCheck();
    }
}
